import React from 'react';

import Message from '../message/message';

const index = () => (
  <Message
    icon="fa-search"
    title="Search Spotify"
    description="Find your favorite songs, artists, albums and playlists."
  />
);

export default index;
